import React, { useState, useEffect } from 'react'
import useStateRef from 'react-usestateref';
import { DataGrid,GridToolbar,GridCellModes  } from '@mui/x-data-grid';
import { Pagination } from "@mui/material";
import Box from '@mui/material/Box';
import { Row, Col, Table,  Form, Modal, Dropdown, } from "react-bootstrap";
import { Link, useNavigate } from 'react-router-dom';
import Card from "../../../../../components/Card";
import CustomToggle from "../../../../../components/dropdowns";
import Button from '@mui/material/Button';
import Select from 'react-select';
import config from "../../../../../config/config";
import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import "../../../../App.css";
import { width } from '@mui/system';
import swal from 'sweetalert';
import { darken, lighten, styled } from '@mui/material/styles';
import {jsPDF} from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'

const getBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.7) : lighten(color, 0.7);

const getHoverBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

const getSelectedBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

const getSelectedHoverBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.4) : lighten(color, 0.4);

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  '& .super-app-theme--Open': {
    backgroundColor: getBackgroundColor(theme.palette.info.main, theme.palette.mode),
    '&:hover': {
      backgroundColor: getHoverBackgroundColor(
        theme.palette.info.main,
        theme.palette.mode,
      ),
    },
    '&.Mui-selected': {
      backgroundColor: getSelectedBackgroundColor(
        theme.palette.info.main,
        theme.palette.mode,
      ),
      '&:hover': {
        backgroundColor: getSelectedHoverBackgroundColor(
          theme.palette.info.main,
          theme.palette.mode,
        ),
      },
    },
  },
  '& .super-app-theme--Filled': {
    backgroundColor: getBackgroundColor(
      theme.palette.success.main,
      theme.palette.mode,
    ),
    '&:hover': {
      backgroundColor: getHoverBackgroundColor(
        theme.palette.success.main,
        theme.palette.mode,
      ),
    },
    '&.Mui-selected': {
      backgroundColor: getSelectedBackgroundColor(
        theme.palette.success.main,
        theme.palette.mode,
      ),
      '&:hover': {
        backgroundColor: getSelectedHoverBackgroundColor(
          theme.palette.success.main,
          theme.palette.mode,
        ),
      },
    },
  },
  '& .super-app-theme--PartiallyFilled': {
    backgroundColor: getBackgroundColor(
      theme.palette.warning.main,
      theme.palette.mode,
    ),
    '&:hover': {
      backgroundColor: getHoverBackgroundColor(
        theme.palette.warning.main,
        theme.palette.mode,
      ),
    },
    '&.Mui-selected': {
      backgroundColor: getSelectedBackgroundColor(
        theme.palette.warning.main,
        theme.palette.mode,
      ),
      '&:hover': {
        backgroundColor: getSelectedHoverBackgroundColor(
          theme.palette.warning.main,
          theme.palette.mode,
        ),
      },
    },
  },
  '& .super-app-theme--Rejected': {
    backgroundColor: getBackgroundColor(
      theme.palette.error.main,
      theme.palette.mode,
    ),
    '&:hover': {
      backgroundColor: getHoverBackgroundColor(
        theme.palette.error.main,
        theme.palette.mode,
      ),
    },
    '&.Mui-selected': {
      backgroundColor: getSelectedBackgroundColor(
        theme.palette.error.main,
        theme.palette.mode,
      ),
      '&:hover': {
        backgroundColor: getSelectedHoverBackgroundColor(
          theme.palette.error.main,
          theme.palette.mode,
        ),
      },
    },
  },
}));


const TableData = (props) => {
	console.log('testing page')
	
  const today = new Date();
  const numberOfDaysToAdd = 0;
  const date = today.setDate(today.getDate() + numberOfDaysToAdd); 
  const defaultValue = new Date(date).toISOString().split('T')[0] // yyyy-mm-dd
  var Finyear=sessionStorage.getItem("FinYear");
  Finyear=Finyear.substring(0,4);

	useEffect(() => {
    setpage(1);
    setuserId(0);
    setacmaster(0);
    getLookup();
 ;

    //  document.getElementById("txtFromDate").value=(new Date()).toISOString().substring(0,10);
    //  document.getElementById("txtTodate").value=(new Date()).toISOString().substring(0,10);

  }, []);

const listPg = (event, value) => {
    setpage(value);
    setuserId(0);
    getLookup();
   
   
  };

  const navigate = useNavigate();
  const ActionAdd = () => {
	  sessionStorage.setItem("UserManagement_Action", "Add");
	  sessionStorage.setItem("UserManagement_EditId", "0");
    navigate('../dashboard/table/admin/usermanagement/entry');
  };


  const ActionEdit = (menuName,groupId,selectGroupId,Department) => {
	  
	sessionStorage.setItem("UserManagement_Action", "Edit");
    //sessionStorage.setItem("UserManagement_EditId", editid);
    sessionStorage.setItem("UserManagement_GroupId", groupId);
    sessionStorage.setItem("UserManagement_MenuName", menuName);
    sessionStorage.setItem("UserManagement_selectGroupId", selectGroupId);
    sessionStorage.setItem("UserManagement_Department", Department);
    navigate('../dashboard/table/admin/usermanagement/entry');
  };

const ActionDelete = (editid) => {
	  
	sessionStorage.setItem("UserManagement_Action", "Delete");
    sessionStorage.setItem("UserManagement_EditId", editid);
    navigate('../dashboard/table/admin/usermanagement/entry');
  };

  const [DtUserGroup, setUserGroup]=useState([]);
  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const [GroupId, setGroupId, GroupIdRef] = useStateRef();
  const [userId, setuserId, userIdRef] = useStateRef('0');
  const [nopage, setnopage, nopageRef] = useStateRef();
  const [page, setpage, pageRef] = useStateRef('1');
  const [acmaster, setacmaster, acmasterRef] = useStateRef('0');
  const [totalCount, settotalCount, totalCountRef] = useStateRef();
  const [currentpg, setcurrentpg, currentpgRef] = useStateRef();
  const [GridData, setGridData] = useState([]);
  const handleClose1 = () => setShow1(false);
  const [isDisabled, setisDisabled]=useState(false);
  const [Search, setSearch, SearchRef] = useStateRef('');
  
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [editRowsModel, setEditRowsModel] = React.useState({});
  const [loading, setLoading] = React.useState(false)
  const [btndisabled, setDisabled] = useState('disabled');
  const [newDataRows, setRows] = React.useState([]);
  const [srcURL, setsrcURL] = useState("https://www.google.com");
  const dataRows=[];
 

  
  // useEffect(() => {
    
  // }, [newDataRows]);

  async function getLookup(){
    try {
      setGroupId('1');
     let postData=[];
 
 
     const results = await apiService.postCall("metalreceipt/Lookup",postData);
  
    if (results != "-1") {
 
      setUserGroup(results.data[0][0]);

       }
  
     } catch (error) {
       console.log(error);
     }
 }
 const BackToList = () => {
  setDisabled('disabled');
 
};
const addFooters = doc => {
  const pageCount = doc.internal.getNumberOfPages()
  const todayDate = new Date(date).toISOString().split('T')[0] // yyyy-mm-dd
  const printOn=moment(todayDate).format("DD-MM-YYYY");
  doc.setFont('times', 'normal')
  doc.setFontSize(8)
  for (var i = 1; i <= pageCount; i++) {
      doc.setPage(i)
      //doc.text('Page ' + String(i) + ' of ' + String(pageCount), doc.internal.pageSize.width / 2, 800, {
      //    align: 'right'
      //})
      let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber; //Current Page
      doc.text('Page: ' + pageCurrent, 200, 10, 'right');
      doc.text('Printed on : ' + printOn, 200, doc.internal.pageSize.height - 10, 'right');
      //doc.text('Printed by : ' + _userFirstName.toString() + ' ' + _userLastName.toString(), 900, doc.internal.pageSize.height - 20);
      //doc.text('Print On : ' + printOn, 900, doc.internal.pageSize.height - 10);

  }
}

async function GenereatePdf(){
  try
  {
debugger;
   
    var pdfDoc = new jsPDF('a4');
    var pdfYpos=10;
    pdfDoc.text("Avathar Jewells", 100, pdfYpos, 'center');
    pdfYpos=pdfYpos+10;
    pdfDoc.setFontSize(10);
    pdfDoc.setFont("Times", "bold");
    var fdate=moment(document.getElementById("txtFromDate").value).format("DD-MM-YYYY");
    var tdate= moment(document.getElementById("txtToDate").value).format("DD-MM-YYYY");
    if (GroupId==1){
      pdfDoc.text("GOLD: Dealer Ledger "+fdate +" To "+ tdate, 100, pdfYpos, 'center');
    }
    else {
      pdfDoc.text("SILVER: Dealer Ledger "+fdate +" To "+ tdate, 100, pdfYpos, 'center');
    }
    
    pdfYpos=pdfYpos+10;
    //pdfDoc = pdfFunction(pdfDoc, GridData);

    debugger;
    var headData = [];
    var tempBody = [];
    
    headData.push({
     AccCode: "AccCode ",
     AccDesc: "Party Name",
     Closing: "Closing",
   })
   var bodyheightTwo=0;
   for (var i=0;i<=GridData.length-1;i++){

    tempBody.push({
      AccCode: GridData[i].AccCode,
      AccDesc: GridData[i].AccDesc,
      Closing: GridData[i].Closing,
    })
  
  }
  
    autoTable(pdfDoc, {
      startY: pdfYpos,
      head: headData,
      body: tempBody,
      tableWidth: 300,
      margin: {
        top: 20,
        bottom: 60,
        left: 10,
        right: 10,
        width: 300
    },
    willDrawCell: function (data) {
      if (data.row.section === 'body') {
          var height = (data.table.body.length + 1) * data.table.body[0].height;
          bodyheightTwo = height;
      }
  },
    styles: {
      overflow: 'linebreak', cellwidth: 'auto'
    },
    headStyles: {
        fontfamily: "Times", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
    },
    theme: "grid",
    bodyStyles: { fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },

    columnStyles: {
        0: { halign: "left", cellWidth: 50 }, //Employee name 
        1: { halign: "left", cellWidth: 100 },//Hrs
        2: { halign: "right", cellWidth: 25 },//Rate
        },
    })
    addFooters(pdfDoc);
    //const iframe = doc.getElementById('docpdf');
    setsrcURL(pdfDoc.output('datauristring'));
    setShow1(true);
    //<iframe src={pdf.output('datauristring')}/>
    //pdf.save("testing.pdf");

  }

  catch (error) {
    console.log(error);
  }
}


 async function SaveFunc(){
  try
  {
    setLoading(true);
     
   
      var results;

    debugger;
        let postData = {
          
          "fromDate" :document.getElementById("txtFromDate").value,
          "toDate" : document.getElementById("txtToDate").value,
          "finyear" : Finyear
        }
        debugger;
        let GroupId=String(GroupIdRef.current)
        if (GroupId==1){
          results = await apiService.postCall("smithreport/dealerledgergold",postData);
        }
        else {
          results = await apiService.postCall("smithreport/dealerledgersilver",postData);
        }
        
         debugger;

         
       
         if (results != "-1") {
           setLoading(false);
           setGridData(results.data[0]);
           settotalCount(results.totalCount);
           setcurrentpg(postData.PageNumber);
           console.log(results.data[0])
         }
  
debugger;
setLoading(false);
 if (results != "-1" && results !=undefined) {

if(results.errorCode=="8888")
{


swal({

  title: "Alert",
  text: results.data,
  icon: "info",
  button: "Ok"
  
}).then(function () {
  
});

return;

}  

 
    }
  }
  catch (error) {
    console.log(error);
  }

}



  
const columns=[
 
  {
    field: 'AccCode',
  headerName: 'Account Code',
  width: 150,
  align: 'left',
  headerAlign: 'left',
  editable: true,
  
  },
  {
    field: 'AccDesc',
    headerName: 'Party Name',
    align: 'left',
   headerAlign: 'left',
   editable: false,
   width: 400,
    },
  {
    field: 'Closing',
    headerName: 'Closing',
    align: 'left',
    headerAlign: 'left',
    editable: false,
    width: 200,
    }
    
   
]




  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
           
           
              <div className="header-title">
                <h4 className="card-title">Dealer Ledger All</h4>
              </div>
             
              <Modal {...props}  size="lg"
            aria-labelledby="contained-modal-title-vcenter"
             centered show={show1} onHide={handleClose1} >
                  <Modal.Header closeButton>
                    <Modal.Title>{sho} Dealer Ledger</Modal.Title>
                   
                  </Modal.Header>
                  <Modal.Body>
                  <iframe  id="docpdf"  src={srcURL} 
                         height="500"
                         width="720"
                         allowFullScreen={true}/>

                  </Modal.Body>
                </Modal>


            </Card.Header>

            <Card.Body>

                        
            <div className='container-fluid py-4 '>
                    <div className='row py-2'> 

                       <div className='col-md-3'>
                            <Form.Label>From Date</Form.Label>
                            <Form.Control type="date" id="txtFromDate" placeholder="" defaultValue={defaultValue} />
                          </div>

                          <div className='col-md-3'>
                            <Form.Label>To Date</Form.Label>
                            <Form.Control type="date"  id="txtToDate" placeholder="" defaultValue={defaultValue} />
                          </div>

                        <div className='col-md-3'>
                            <Form.Label>Metal</Form.Label>
                             <Select className="" id="txtUserGroup" 
                             options={DtUserGroup}
                             isDisabled={isDisabled}
                             value={DtUserGroup.filter(function(option) {
                               
                              return option.value === GroupId;
                            })}
                            onChange=
                            {
                              (e) => {
 
                                 setGroupId(e.value);
                                 setGridData([]);
                              }
                              }
                             disabled={false}>
              								
							               </Select>
                          </div>

                          <div className='col-md-3' style={{marginTop : 35}}>
                         
                          <Button type="button" variant="contained" onClick={SaveFunc}>View</Button> &nbsp;&nbsp;&nbsp;
                          <Button type="button"  variant="contained" onClick={GenereatePdf}>Print</Button>
                          </div>
                        
                        </div>
                        </div>

                        <div className='pt-1' style={{ direction: 'rtl' }} >
                       
                        <Form.Group className="form-group">
                  
                 
               
                  
                </Form.Group>
             

              </div>

               <Box sx={{ height: 400, width: 1,
               '.MuiDataGrid-columnHeaderTitle': { 
                fontWeight: 'bold !important',
                overflow: 'visible !important'
             },
             '& .super-app-theme--cell': {
              backgroundColor: 'rgba(157, 255, 118, 0.49)',
              color: '#1a3e72',
              fontWeight: '600',
            },
            '& .super-app.positive': {
              backgroundColor: '#d47483',
              color: '#1a3e72',
              fontWeight: '600',
            },
              }}>
                  <StyledDataGrid
                   //checkboxSelection
                   editMode="row"
                    rows={GridData}
                    columns={columns}
                    getRowClassName={(params) => `super-app-theme--${params.row.status}`}
                    getRowId={(row) =>  row.AccCode}
                     showCellVerticalBorder 
                     showColumnVerticalBorder 
                     loading={loading}
                    slots={{ toolbar: GridToolbar }}
                   
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 10
                        }
                      }
                    }}

                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                      
                      },
                    }}
                  />
                </Box>

            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default TableData;
